import {
  ChildUser,
  CustomReward,
  CustomRewardCurrency,
} from "@joonapp/web-shared"

export interface CustomRewardTemplate {
  id: number // this is the template_id
  title: string
  cost: number
  emoji: string
  currency: CustomRewardCurrency
}

export interface OnboardingCustomRewardTemplate extends CustomRewardTemplate {
  user_id: number
}

export interface OnboardingCustomRewardTemplateWithUserIds
  extends OnboardingCustomRewardTemplate {
  user_ids: number[]
}

export enum ScreenTimeControlsModalType {
  POST_CREATE = "post_create", // when user came from just creating a screen time reward
  REWARDS_TAB = "rewards_tab", // when user came from "Finish Set up (2 min)"
  REWARDS_DETAILS = "rewards_details", // when user came from "Screen time controls Help" or "Set up screen time controls" on reward details page
  FTUX = "ftux", // when user came from ftux on rewards tab
}

export interface ScreenTimeScheduledException {
  id: number
  user_id: number
  weekday: string // ("sunday", "monday"...)
  start_time: string // (format: "10:00 AM")
  end_time: string // (format: "8:00 PM")
}

export interface ScreenTimeManualException {
  id: number
  user_id: number
  end_datetime: string // (full iso format) // When the exception is to end
}

export enum ScreenTimeRestrictionsConfirmationModalType {
  SCHEDULE = "schedule",
  TURN_OFF = "turn_off",
  TURN_ON = "turn_on",
}

export interface ScreenTimeLog {
  id: number
  user_id: number
  minutes: number
  remote_ending_allowed: boolean
  date_created: string // iso format (date_created + abs(minutes) == end datetime of the session)
  user: ChildUser
  reward: CustomReward
}
